import React from 'react';
import CardHeader from "@mui/material/CardHeader";
import Stack from "@mui/material/Stack";
import IconButton from "@mui/material/IconButton";
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

function toPersianNum(num, dontTrim) {

    if (num === '') {
        return '';
    }

    var i = 0,

        dontTrim = dontTrim || false,

        num = dontTrim ? num.toString() : num.toString().trim(),
        len = num.length,

        res = '',
        pos,

        persianNumbers = typeof persianNumber == 'undefined' ?
            ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'] :
            persianNumbers;

    for (; i < len; i++)
        if ((pos = persianNumbers[num.charAt(i)]))
            res += pos;
        else
            res += num.charAt(i);

    return res;
};
const MessagesHeader = ({settingMenuCallback, unread}) => {
    return (
        <CardHeader
            title={toPersianNum(unread) + " " + "پیام جدید"}
            // subheader={unread}
            // style={{fontFamily: 'Iran',fontWeight:'Bold'}}

            action={
                <Stack direction="row" alignItems="center" sx={{mr: 1}}>
                    {/*<IconButton aria-label="compose">*/}
                    {/*    <ModeEditIcon fontSize={"small"}/>*/}
                    {/*</IconButton>*/}
                    {/*<IconButton aria-label="starred">*/}
                    {/*    <StarBorderIcon fontSize={"small"}/>*/}
                    {/*</IconButton>*/}
                    {/*<IconButton edge={"end"} aria-label="starred" onClick={settingMenuCallback}>*/}
                    {/*    <MoreHorizIcon fontSize={"small"}/>*/}
                    {/*</IconButton>*/}
                </Stack>
            }
            sx={{
                '& .MuiCardHeader-title': {
                    fontFamily: 'Iran'
                },
                '& .MuiCardHeader-subheader': {
                    fontFamily: 'Iran'
                },
                '& .MuiCardHeader-action': {
                    alignSelf: 'center',
                }
            }}

        />
    );
};

export default MessagesHeader;
